import apiAction from "../ajax/service"

const verifyBulkAction = async () =>{
   return await apiAction('bulkaction',{bulkAction:'verify_bulk_action'},'bulkAction')
}

export {verifyBulkAction}